exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pro .profile-menu-item_link{align-items:center!important;cursor:pointer}", ""]);

// exports
